import React, { useEffect, useRef, useState } from "react";
import CommonDropdown from "../CommonDropdown";
import IncomingCalls from "./IncomingCalls";
import MissedCalls from "./MissedCalls";
import OutGoingCalls from "./OutGoingCalls";
import VoiceMails from "./VoiceMails";
import IncomingText from "./IncomingText";
import OutGoingText from "./OutGoingText";
import RingCentralCard from "./RingCentralCard";
import { useDispatch, useSelector } from "react-redux";
import { getRingCentralCardData } from "./RingCentralSlice";
import { printDocument } from "../../../ChartsJs/DownlaodExportImage";

const RingCentralIndex = () => {
  const { RingCentralCardData } = useSelector((state) => state.ringcentral);

  const { selectedMonth, refresh, type, year, metrics } = useSelector(
    (state) => state.revenue
  );

  const [IncomingCall, setIncomingCall] = useState([]);
  const [Outgoincall, setOutgoingCall] = useState([]);
  const [MissedCall, setMissedCall] = useState([]);
  const [VoiceMail, setVoiceMail] = useState([]);
  const [IncomingMessage, setIncomingMessage] = useState([]);
  const [OutgoingMessage, setOutgoingMessage] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (RingCentralCardData && RingCentralCardData != undefined) {
      const IncomingCall = RingCentralCardData?.Table0Records;
      setIncomingCall(IncomingCall);
      const OutgoingCall = RingCentralCardData?.Table1Records;
      setOutgoingCall(OutgoingCall);
      const MissedCall = RingCentralCardData?.Table2Records;
      setMissedCall(MissedCall);
      const VoiceMail = RingCentralCardData?.Table3Records;
      setVoiceMail(VoiceMail);
      const IncomingMsg = RingCentralCardData?.Table5Records;
      setIncomingMessage(IncomingMsg);
      const OutText = RingCentralCardData?.Table6Records;
      setOutgoingMessage(OutText);
    }
  }, [RingCentralCardData]);

  const RingCentralRef = useRef();
  const handlePrintDocument = () => {
    const orientation = "portrait"; 
    printDocument(RingCentralRef, "RingCentral",orientation);
  };

  return (
    <>
      <button
        className="pfdexportIcon"
        onClick={handlePrintDocument}
        title="Download Full Screen"
      >
        <i className="lar la-file-pdf"></i>
      </button>
      <div className="pdfContent" ref={RingCentralRef}>
        <div className="page-header">
          <div className="row">
            <div className="col-sm-3">
              <h3 className="page-title">Ring Central</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Ring Central</li>
              </ul>
            </div>
            <div className="col-sm-9">
              <CommonDropdown RingCentral={true} />
            </div>
          </div>
        </div>

        <div className="row six-cols">
          <RingCentralCard type={type} Year={year} />
        </div>
        <div className="row">
          <div className="col-md-6">
            <IncomingCalls
              IncomingCall={IncomingCall}
              type={metrics.type}
              refresh={refresh}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="Accepted"
            />
          </div>
          <div className="col-md-6">
            <OutGoingCalls
              Outgoincall={Outgoincall}
              type={metrics.type}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="Call Connected,Hang Up"
            />
          </div>
          <div className="col-md-6">
            <MissedCalls
              MissedCall={MissedCall}
              type={metrics.type}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="Missed"
            />
          </div>
          <div className="col-md-6">
            <VoiceMails
              VoiceMail={VoiceMail}
              type={metrics.type}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="VoiceMail"
            />
          </div>
          <div className="col-md-6">
            <IncomingText
              IncomingMessage={IncomingMessage}
              type={metrics.type}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="Inbound"
              refresh={refresh}
            />
          </div>
          <div className="col-md-6">
            <OutGoingText
              OutgoingMessage={OutgoingMessage}
              type={metrics.type}
              filter={metrics.filter}
              metric={metrics.metrices}
              Year={year}
              value="Outbound"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RingCentralIndex;
